import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';
import { fitBounds } from 'google-map-react/utils';
import * as mapStyles from "./styles/mapStyles";
import * as appDataTransformations from "./appDataTransformations.js";
import * as MapElements from "./MapElements.jsx";
import * as visualAssets from "./visualAssets.jsx";
import * as Transform from "./DataTransformations.jsx";
import * as tools from "./tools.jsx";
import * as audioTools from "./AudioTools.js";
import * as clustering from "./Clustering.js";

const standardScandinavianExtremes =
{
  sw:{lat:53, lng:5,},
  ne:{lat:60, lng: 17},
}
var mapOptions = {
      overviewMapControl: false,
      streetViewControl: false,
      rotateControl: false,
      mapTypeControl: false,
      mapTypeId:"satellite",
      // disable poi
      //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
      //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
      }

var mapContainerStyle =
{
   backgroundColor:"#FF0000",

}

const mapDefaultCenter = {lat: 56.95, lng: 15.33};


export class ExploreMap extends React.Component {
   constructor(props)
   {
      super(props);
      this.state = {
        center:mapDefaultCenter,
        zoom: 12,
        hoverKey:null,
        selectedKey:null,
         errorMsgs:[],
         compositions:null,
         users:null,
         contexts:null,
         tags: null,
         compsWithData: null,
         loneComps: [],
         clusters: [],
        //mapNeedsToAdapt: true,
      }
      this.lastCompExtremes = null;
      this.audioCtx = audioTools.getAudioContext();
      this.isMobile = window.mobilecheck();

      this.compIdsInBounds = [];
      this.clusteringBasedOnIds = null;
      this.clusteringBasedOnZoom = null;
      this.clusterData = {clusters:[]};
      this.zoomInterval = null;
  }
  componentWillMount()
  {
    console.log("Mounting");
      this.props.appCallbacks.performAjaxRequest("compositions", "GET", null, tools.getSetBaseDataFunc(this, "compositions", "errorMsgs"), false);
      this.props.appCallbacks.performAjaxRequest("users", "GET", null, tools.getSetBaseDataFunc(this, "users", "errorMsgs"), false);
      this.props.appCallbacks.performAjaxRequest("contexts", "GET", null, tools.getSetBaseDataFunc(this, "contexts", "errorMsgs"), false);
      this.props.appCallbacks.performAjaxRequest("tags", "GET", null, tools.getSetBaseDataFunc(this, "tags", "errorMsgs"), false);
  }
  componentWillUnmount()
  {
    this.audioCtx.close();
  }
   adaptMap(extremes)
   {
    if(this._googleMapCompRef)
    {
      const mapDomNode = ReactDOM.findDOMNode(this._googleMapCompRef.refs.google_map_dom);

      const mapsBoundsRect = mapDomNode.getBoundingClientRect();
      
      const size = {
          width: mapsBoundsRect.width, // Map width in pixels
          height: mapsBoundsRect.height, // Map height in pixels
        };
      
      const centerAndZoom = fitBounds(extremes, size);
      this.mapBoundsSW = centerAndZoom.newBounds.sw;
      this.mapBoundsNE = centerAndZoom.newBounds.ne;

      //console.log("Fit to bounds: ", centerAndZoom);
      this.setState({zoom:centerAndZoom.zoom - 1});
      this.setState({center:centerAndZoom.center});
    }
   }

   boundsChanged(center, zoom, bounds)
   {
    if(this.state.compsWithData && this.zoomInterval == null)
    {
      const sw = {lat:bounds[2], lng:bounds[1]};
      const ne = {lat:bounds[0], lng:bounds[3]};

      const filterOnBounds = (c) => {
        const pos = c.position;
        if(pos.lat < sw.lat || pos.lat > ne.lat || pos.lng < sw.lng || pos.lng > ne.lng) {
          return false;
        }
        return true;
      }
      this.compIdsInBounds = new Set(this.state.compsWithData.filter(filterOnBounds).map((c)=>{return c.composition_id}));

      //Calculate clustering according to zoom level and compIdsInBounds
      if(this.clusteringBasedOnZoom != zoom ||
        !tools.setsAreEqual(this.clusteringBasedOnIds, this.compIdsInBounds))
      {
        this.clusteringBasedOnZoom = zoom;
        this.clusteringBasedOnIds = this.compIdsInBounds;
        
        const compsInBounds = [...this.compIdsInBounds].map((cId)=>{
          return this.state.compsWithData.find((c)=>{
            return c.composition_id == cId;})});
      
        const clusterData = clustering.calculateClusters(compsInBounds, 25, sw.lat, ne.lat - sw.lat, sw.lng, ne.lng - sw.lng);


        const loneComps = compsInBounds.filter((c)=>{
          return clusterData.loneIds.includes(c.composition_id)});

        this.setState({clusters: clusterData.clusters});
        this.setState({loneComps: loneComps});

        //console.log("Clusters: ", this.clusters);
        //console.log("Cluster Data: ", clusterData);
      }

    }
   }

   clickedCluster(cluster)
   {
    //console.log("Clicked CLuster: ", cluster);

    const mapDomNode = ReactDOM.findDOMNode(this._googleMapCompRef.refs.google_map_dom);

    const mapsBoundsRect = mapDomNode.getBoundingClientRect();
      
    const size = {
      width: mapsBoundsRect.width, // Map width in pixels
      height: mapsBoundsRect.height, // Map height in pixels
    };


    const extremes = tools.findSWNEExtremes(this.state.compsWithData.filter((c)=>{
      return cluster.compIds.includes(c.composition_id)}).map((obj)=>obj.position));

    const centerAndZoom = fitBounds(extremes, size);
    
    //console.log("Fit to bounds: ", centerAndZoom);

    //this.startAnimateTo(centerAndZoom.center, centerAndZoom.zoom - 1);
    this.setState({zoom:centerAndZoom.zoom - 1});
    this.setState({center:centerAndZoom.center});
   }

  setupMapStyle()
  {
    if(this._googleMapCompRef && this._googleMapCompRef.map_ && this._googleMapCompRef.maps_)
      {
        if(!this.isMobile)
        {
          //console.log("Setting google map custom style.");
          const mapsAPI = this._googleMapCompRef.maps_;
         
          //this._googleMapDomRef.styles = mapStyles.googleMapJSONStyle;
          const styledMapType = new this._googleMapCompRef.maps_.StyledMapType(mapStyles.googleMapJSONStyle);

          
          //Associate the styled map with the MapTypeId and set it to display.
          this._googleMapCompRef.map_.mapTypes.set('styled_map', styledMapType);
          this._googleMapCompRef.map_.setMapTypeId('styled_map');
        }
        else
        {
          //this._googleMapCompRef.map_.setMapTypeId("roadmap");
        }
        this.mapIsSetup = true;
      }
      this.forceUpdate();
   }

  distanceToMouse(markerPos, mousePos, markerProps)
  {
    const x = markerPos.x;
    const y = markerPos.y - MapElements.K_MARKER_HEIGHT * 0.5;
    return Math.sqrt((x - mousePos.x) * (x - mousePos.x) + (y - mousePos.y) * (y - mousePos.y));

  }

  componentWillUpdate(nextProps, nextState)
  {
   
    if(this.state.compsWithData == null)
    {
      const hasFullData = 
        nextState.compositions &&
        nextState.contexts &&
        nextState.users &&
        nextState.tags;

      if(hasFullData)
      { 
        //console.log("Has full Data");
        const compsWithData = appDataTransformations.inlineDataIntoCompositions(
          nextState.compositions, nextState.users, nextState.tags, nextState.contexts);
      
        this.setState({compsWithData:compsWithData});
        //console.log("Data has changed. Has full: " + hasFullData + " and comps with data: ", compsWithData);

        const newExtremes = compsWithData.length == 0 ? standardScandinavianExtremes :
          tools.findSWNEExtremes(compsWithData.map((obj)=>obj.position));

        this.adaptMap(newExtremes);
      }
    }
    
  }

  startAnimateTo(center, zoomLevel)
  {
    const originalCenter = this.state.center;
    const originalZoom = this.state.zoom;

    const steps = 5;
    const self = this;
    var iter = 1;
    const funct = () =>
    {
      const iterFrac = iter / steps;
      const iterSqrd = iterFrac * iterFrac;
      const newCenter =
      {
        lat: (originalCenter.lat * (1 - iterFrac) + center.lat * iterFrac),
        lng: (originalCenter.lng * (1 - iterFrac) + center.lng * iterFrac),
      }

      const newZoom = Math.floor((originalZoom * (1 - iterSqrd) + zoomLevel * iterSqrd));
     //console.log("Animate zoom to center: ", newCenter, newZoom);

      if(iter == steps)
      {
        clearInterval(this.zoomInterval);
        this.zoomInterval = null;
      }
      self.setState({center:newCenter});

      self.setState({zoom: newZoom});

      iter += 1;
    }
    this.zoomInterval = setInterval(funct, 200);
  }

  setHoverKey(key)
  {
    //console.log("Hover key: ", key);
     // console.log("props: ", this.props);
    this.setState({hoverKey: key});
  }

  setSelectedKey(key)
  {
    if(key == null) {
      this.setState({hoverKey: null});
    }
    if (this.state.selectedKey) {
      this.setState({selectedKey: null});
    }
    else {
      this.setState({selectedKey:key});
    }
    //console.log("Selected key: ", key);
  }

  mapClick(e) {
    //console.log("Map Click:", e);
    //this.setState({selectedKey:null});
  } 
   render() {
    //console.log("Render map");
    const topOffset = this.props.topOffset ? this.props.topOffset : 0;

/*
    var clusterData = {clusters:[]};
    if(this.extremes && this.state.compsWithData )
    {
      const sw = this.mapBoundsSW;
      const ne = this.mapBoundsNE;
      clusterData = clustering.calculateClusters(this.state.compsWithData, 50, 50, sw.lat, ne.lat - sw.lat, sw.lng, ne.lng - sw.lng);
      console.log("Clusters: ", clusterData);
    }
    */
    /*
    const hoverComp = this.props.compositions.find((c)=>{return c.composition_id == selectedCompId});
    
    var compsWithSelectedLast = null;

   // console.log("Selcomp: ", selectedComp);
    if(hoverComp)
    {
      compsWithSelectedLast = this.props.compositions.filter((comp)=>{return comp != hoverComp});
      compsWithSelectedLast.push(hoverComp);
      //console.log("reordered: ", compsWithSelectedLast);

    }
    else
    {
      compsWithSelectedLast = this.props.compositions;
    }
*/

const gradientTopStyle = {
  zIndex:100,
  position:"absolute",
  top:-5, left:0, right:0,
  height:"32px",
  backgroundImage: visualAssets.verticalGradientWTTURL,
  backgroundSize: "100% 100%",
}
const gradientBottomStyle = {...gradientTopStyle,
  backgroundImage: visualAssets.verticalGradientTTWURL,
  top:"undefined", bottom:0,
}

const testClusterStyle = {
  width:10,
  height:10,
  position:"relative",
  backgroundColor:"red",
}
      return (
        <div className={"mapSurround"} style={{position:"relative", height:"100%", width:"100%",overflow:"auto"}}>
          <GoogleMapReact onClick={this.mapClick.bind(this)} hoverDistance={10} bootstrapURLKeys={{key:"AIzaSyA3jDZgzpuoyAJ41dc9Nqs6D2lNjw3Tv5w"}}
              ref={(ref)=>this._googleMapCompRef=ref}  options={mapOptions} onGoogleApiLoaded={this.setupMapStyle.bind(this)}  
              onChildClick={()=>{console.log("Child CLick")}} style={{position:"relative", height:"100%", width:"100%"}}
              onChildMouseEnter={this.setHoverKey.bind(this)} onChildMouseLeave={()=>this.setHoverKey(null)}
              defaultCenter={mapDefaultCenter} customMapStyle={mapStyles.googleMapJSONStyle}
              onBoundsChange={this.boundsChanged.bind(this)}
              defaultZoom={12} onChange={null} center={this.state.center} zoom={this.state.zoom}
              distanceToMouse={this.distanceToMouse} hoverDistance = {MapElements.K_MARKER_HEIGHT * .6} yesIWantToUseGoogleMapApiInternals={true}>
              {
                this.state.compsWithData == null ? null :
                this.state.loneComps.map((c)=>
                  <MapElements.SoundmapNeedle audioCtx={this.audioCtx} data={c} keyId={c.composition_id} selectedKey={this.state.selectedKey} hoverKey={this.state.hoverKey}
                  key={c.composition_id} lat={c.position.lat} lng={c.position.lng} onSelect={this.setSelectedKey.bind(this)}/>)
              }
              {this.state.clusters.map((c)=><MapElements.SoundmapClusterNeedle onClusterClick={this.clickedCluster.bind(this)} key={c.id} cluster={c} lat={c.meanPos.lat} lng={c.meanPos.lng}
                  style={testClusterStyle} selectedKey={this.state.selectedKey} hoverKey={this.state.hoverKey}/> )}
          </GoogleMapReact>
          <div style={gradientTopStyle} />
          {this.isMobile ? <div style={gradientBottomStyle} /> : null }
        </div>

      );
   }
}




// WEBPACK FOOTER //
// ./js/ExploreMap.jsx